export const updateReportAccidentService = (fetch) => async (report) => {
  try {
    const response = await fetch({
      url: `/api/v1/siniestros-viales/reportes/${report.id}`,
      method: "put",
      body: report,
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
